@if (customHeaderTemplate) {
  <ng-container [ngTemplateOutlet]="customHeaderTemplate" />
} @else {
  <app-dialog-title>
    <ng-content></ng-content>
  </app-dialog-title>
}

<button
  app-icon-button
  class="dialog-close-button"
  (click)="closeDialog()"
>
  <app-svg-icon
    buttonIcon
    name="cancel"
  />
</button>
